import React from 'react';
import { T, useTranslation } from '@colonist/ui';
import styles from './GameDetailsSettingsTable.module.scss';
export const GameDetailsSettingsTable = ({ game })=>{
    const { t } = useTranslation();
    const settings = game.settings;
    if (settings == undefined) return null;
    const robberLabel = t({
        key: `strings:game.settings.gameInfoTab.friendlyRobber.options.${settings.friendlyRobber ? 'Active' : 'Inactive'}`
    });
    const karmaLabel = t({
        key: `strings:game.settings.gameInfoTab.karma.options.${settings.karmaActive ? 'Active' : 'Inactive'}`
    });
    const bankCardsLabel = t({
        key: `strings:game.settings.gameInfoTab.bankCards.options.${settings.hideBankCards ? 'Hidden' : 'Showing'}`
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("table", {
        className: styles.table
    }, /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.gameInfoTab.id.value',
            options: {
                id: settings.id
            }
        }
    })), /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.gameInfoTab.map.value',
            options: {
                mapName: t(settings.mapName)
            }
        }
    }))), /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.gameInfoTab.gameMode.value',
            options: {
                modeName: t(settings.modeName)
            }
        }
    })), /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.gameInfoTab.extension.value',
            options: {
                extensionName: t(settings.extensionName)
            }
        }
    }))), /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.gameInfoTab.scenario.value',
            options: {
                scenarioName: t(settings.scenarioName)
            }
        }
    })), /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.gameInfoTab.vpToWin.value',
            options: {
                value: game.victoryPointsToWin
            }
        }
    }))), /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.gameInfoTab.turnTimer.value',
            options: {
                turnTimer: t(settings.turnTimerText)
            }
        }
    })), /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.gameInfoTab.friendlyRobber.value',
            options: {
                friendlyRobberState: robberLabel
            }
        }
    }))), /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.gameInfoTab.karma.value',
            options: {
                karmaState: karmaLabel
            }
        }
    })), /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.gameInfoTab.dice.value',
            options: {
                diceSetting: t(settings.diceText)
            }
        }
    }))), /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.gameInfoTab.bankCards.value',
            options: {
                bankCardsVisibility: bankCardsLabel
            }
        }
    })), /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:profilePage.history.table.turns.value',
            options: {
                turnCount: game.turnCount
            }
        }
    }))), /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.settings.gameInfoTab.cardDiscardLimit.value',
            options: {
                value: settings.cardDiscardLimit
            }
        }
    }))))));
};
